document.addEventListener('DOMContentLoaded', function() {


    const DEV = 1;
    
    const ACTIVE_POSITION = 0;  // Change this to any position 0-4
    const NEXT_INCREASES_POSITION = false;  // Set to false to reverse direction
    const PREV_NEXT_PAUSING_TIME = 0 // in ms, how much time before next action available


    // ===================================

    const wrapper = document.getElementById('anim_slider_container')
    if(wrapper==null) {return;}

    const btn_next = wrapper.querySelectorAll('.btn_next')
    const btn_prev = wrapper.querySelectorAll('.btn_prev')

    btn_next.forEach(function(btn){
      btn.addEventListener('click', moveNext);  
    })
    btn_prev.forEach(function(btn){
        btn.addEventListener('click', movePrev);
    })

    const slides = Array.from(wrapper.querySelectorAll('.slide'));
    const touchOverlay = wrapper.querySelector('.touch_overlay');
    const dots = Array.from(wrapper.querySelectorAll('.dot'));
    const info = wrapper.querySelector('#info');
    
    if (slides.length === 0) {
        DEV && log('No slides found!');
        return;
    }

    let isAnimating = false;
    
    // Touch tracking
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    let touchStartTime = 0;
    let isDragging = false;
    let dragDistance = 0;
    let velocity = 0;
    
    // Constants
    const SWIPE_THRESHOLD = 50;
    const VELOCITY_THRESHOLD = 0.3;
    const DRAG_MULTIPLIER = 0.2;
    
    // Initialize
    DEV && log('Slider Configuration:', {
        ACTIVE_POSITION,
        NEXT_INCREASES_POSITION,
        direction: NEXT_INCREASES_POSITION ? 'Next increases (0→1→2→3→4)' : 'Next decreases (0→4→3→2→1)'
    });
    updateInfo();
    updateDots();
    
    // Touch events
    wrapper.addEventListener('touchstart', handleTouchStart, { passive: false });
    wrapper.addEventListener('touchmove', handleTouchMove, { passive: false });
    wrapper.addEventListener('touchend', handleTouchEnd);
    wrapper.addEventListener('touchcancel', handleTouchEnd);
    
    // Mouse events for desktop testing
    wrapper.addEventListener('mousedown', handleMouseDown);
    wrapper.addEventListener('mousemove', handleMouseMove);
    wrapper.addEventListener('mouseup', handleMouseUp);
    wrapper.addEventListener('mouseleave', handleMouseUp);
    
    // Dot navigation
    dots.forEach((dot, index) => {
        dot.addEventListener('click', () => jumpTo(index));
    });
    
    function handleTouchStart(e) {
        if (isAnimating) return;
        
        const touch = e.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchEndX = touch.clientX;
        touchStartTime = Date.now();
        isDragging = true;
        dragDistance = 0;
        
        wrapper.classList.add('touching');
        wrapper.classList.add('interacted');
        
        // Update touch overlay position
        const rect = wrapper.getBoundingClientRect();
        const x = ((touch.clientX - rect.left) / rect.width) * 100;
        const y = ((touch.clientY - rect.top) / rect.height) * 100;
        touchOverlay.style.setProperty('--touch-x', `${x}%`);
        touchOverlay.style.setProperty('--touch-y', `${y}%`);
    }
    
    function handleTouchMove(e) {
        if (!isDragging || isAnimating) return;
        
        const touch = e.touches[0];
        touchEndX = touch.clientX;
        const touchEndY = touch.clientY;
        
        const deltaX = touchEndX - touchStartX;
        const deltaY = touchEndY - touchStartY;
        
        // Prevent vertical scrolling if horizontal swipe detected
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            e.preventDefault();
            
            dragDistance = deltaX;
            velocity = deltaX / (Date.now() - touchStartTime);
            
            // Add dragging class for instant visual feedback
            wrapper.classList.add('dragging');
        }
    }
    
    function handleTouchEnd(e) {
        if (!isDragging) return;
        
        isDragging = false;
        wrapper.classList.remove('touching');
        wrapper.classList.remove('dragging');
        
        // Reset drag effect
        slides.forEach(slide => {
            slide.style.transform = '';
        });
        
        const deltaX = touchEndX - touchStartX;
        const touchDuration = Date.now() - touchStartTime;
        const finalVelocity = Math.abs(deltaX / touchDuration);
        
        // Determine if it's a swipe
        if (Math.abs(deltaX) > SWIPE_THRESHOLD || finalVelocity > VELOCITY_THRESHOLD) {
            // Note: Swipe direction mapping
            // Swipe right (deltaX > 0) = show previous slide
            // Swipe left (deltaX < 0) = show next slide
            // If this feels backwards, swap the moveNext() and movePrev() calls below
            if (deltaX > 0) {
                if(window.innerWidth > 1024) {
                    moveNext();
                } else {
                    movePrev();
                }
            } else {
                if(window.innerWidth > 1024) {
                    movePrev();
                } else {
                    moveNext();
                }
            }
        }
        
        // Reset values
        dragDistance = 0;
        velocity = 0;
    }
    
    // Mouse handlers for desktop
    function handleMouseDown(e) {
        handleTouchStart({ touches: [{ clientX: e.clientX, clientY: e.clientY }], preventDefault: () => {} });
    }
    
    function handleMouseMove(e) {
        if (!isDragging) return;
        handleTouchMove({ 
            touches: [{ clientX: e.clientX, clientY: e.clientY }], 
            preventDefault: () => {} 
        });
    }
    
    function handleMouseUp(e) {
        handleTouchEnd({ changedTouches: [{ clientX: e.clientX }] });
    }
    
    function updateAttributes(direction = 'next', skipAnimCheck = false) {
        DEV && log('updateAttributes', direction)

        if (!skipAnimCheck && isAnimating) return;
        
        const positions = slides.map(slide => parseInt(slide.dataset.position));
        DEV && log('Current positions:', positions)
        
        const newPositions = positions.map(pos => {
            if (NEXT_INCREASES_POSITION) {
                // Next increases positions, Prev decreases
                if (direction === 'next') {
                    return (pos + 1) % 5;
                } else {
                    return (pos - 1 + 5) % 5;
                }
            } else {
                // Next decreases positions, Prev increases (original behavior)
                if (direction === 'next') {
                    return (pos - 1 + 5) % 5;
                } else {
                    return (pos + 1) % 5;
                }
            }
        });
        
        DEV && log('New positions:', newPositions)
        
        slides.forEach((slide, index) => {
            const newPos = newPositions[index];
            slide.dataset.position = newPos;
            slide.dataset.active = newPos === ACTIVE_POSITION ? 'true' : 'false';
        });
        
        updateInfo();
        updateDots();
    }

    function updateInfo(focus_index) {
        // Get the slide at the active position
        let focus_slide = wrapper.querySelector(`.slide[data-position="${ACTIVE_POSITION}"]`);
        
        if (!focus_slide) {
            DEV && log('No slide found at active position:', ACTIVE_POSITION);
            return;
        }

        let data = {
            title : $(focus_slide).find('.title').html(),
            text : $(focus_slide).find('.text').html(),
            number : $(focus_slide).find('.number').html()
        }

        $(info).find('.title span.title').html(data.title)
        $(info).find('.text').html(data.text)
        $(info).find('span.number').html(data.number)

        DEV && log('updateInfo - Active slide data:', data)
    }
    
    function moveNext() {
        DEV && log('next')
        if (isAnimating) return;
        isAnimating = true;
        updateAttributes('next', true);  // Pass true to skip the animation check
        setTimeout(() => {
            isAnimating = false;
        }, PREV_NEXT_PAUSING_TIME);
    }
    
    function movePrev() {
        if (isAnimating) return;
        isAnimating = true;
        updateAttributes('prev', true);  // Pass true to skip the animation check
        setTimeout(() => {
            isAnimating = false;
        }, PREV_NEXT_PAUSING_TIME);
    }
    
    function jumpTo(targetIndex) {
        if (isAnimating) return;

        moveNext();
        
        // // Get the target slide
        // const targetSlide = slides[targetIndex];
        // if (!targetSlide) return;
        
        // // Get its current position
        // const currentPos = parseInt(targetSlide.dataset.position);
        
        // // If already in active position, do nothing
        // if (currentPos === ACTIVE_POSITION) return;
        
        // isAnimating = true;
        // wrapper.classList.add('interacted');
        
        // // Calculate steps to active position
        // let steps = 0;
        
        // // Simulate to find how many steps needed
        // let positions = slides.map(s => parseInt(s.dataset.position));
        // const targetOriginalIndex = targetIndex;
        
        // // Try moving next up to 5 times
        // for (let i = 0; i < 5; i++) {
        //     if (positions[targetOriginalIndex] === ACTIVE_POSITION) {
        //         steps = i;
        //         break;
        //     }
        //     // Simulate next move (matching updateAttributes logic)
        //     if (NEXT_INCREASES_POSITION) {
        //         positions = positions.map(p => (p + 1) % 5);
        //     } else {
        //         positions = positions.map(p => (p - 1 + 5) % 5);
        //     }
        // }
        
        // // Now actually perform the moves
        // if (steps > 0) {
        //     let remaining = steps;
        //     const performStep = () => {
        //         updateAttributes('next', true); // Skip animation check for chained calls
        //         remaining--;
        //         if (remaining > 0) {
        //             setTimeout(performStep, 150);
        //         } else {
        //             setTimeout(() => {
        //                 isAnimating = false;
        //             }, 400);
        //         }
        //     };
        //     performStep();
        // } else {
        //     isAnimating = false;
        // }
    }
    
    function updateDots() {
        if(dots==null) {return;}

        const activeSlide = slides.find(s => s.dataset.position === ACTIVE_POSITION.toString());
        const activeIndex = slides.indexOf(activeSlide);
        
        dots.forEach((dot, index) => {
            dot.dataset.active = index === activeIndex ? 'true' : 'false';
        });
    }
    
    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') movePrev();
        if (e.key === 'ArrowRight') moveNext();
    });
    
    // Click slides to navigate
    slides.forEach((slide, index) => {
        slide.addEventListener('click', (e) => {
            if (!isDragging && slide.dataset.active !== 'true') {
                jumpTo(index);
            }
        });
    });
    
    // Prevent zoom on double tap
    let lastTouchEnd = 0;
    document.addEventListener('touchend', (e) => {
        const now = Date.now();
        if (now - lastTouchEnd <= 300) {
            e.preventDefault();
        }
        lastTouchEnd = now;
    }, false);

})

/*
CSS REFERENCE for ACTIVE_POSITION = 0:

Direction depends on NEXT_INCREASES_POSITION setting:

If NEXT_INCREASES_POSITION = true:
- Clicking "Next" increases positions (0→1→2→3→4→0)
- Slides with higher positions should be positioned to the right

.slide[data-position="0"] {
    transform: translateX(0) scale(1);
    opacity: 1;
    z-index: 10;
    // Your main active slide
}

.slide[data-position="1"] {
    transform: translateX(110%) scale(0.9);
    opacity: 0.8;
    z-index: 2;
    // To the right of active
}

.slide[data-position="2"] {
    transform: translateX(220%) scale(0.8);
    opacity: 0.6;
    z-index: 1;
    // Further right
}

If NEXT_INCREASES_POSITION = false:
- Clicking "Next" decreases positions (0→4→3→2→1→0)
- You might want to position slides differently

Adjust your CSS based on your chosen direction!
*/